import React from 'react';
import { Form, Checkbox, FormItemProps } from 'antd';
import { RouteEnum } from 'pro/config/routers';
import { generatePath } from 'ava-util/dist/request';
import { useTrans, Trans } from 'base/utils/i18n';

type FormRegisterAgreeProps = FormItemProps;

const FormRegisterAgree: React.FC<FormRegisterAgreeProps> = props => {
    const { t } = useTrans();
    const {
        name = 'agreement',
        rules = [
            {
                validator: (_, value) =>
                    value
                        ? Promise.resolve()
                        : Promise.reject(new Error(t('web_form_agree_error'))),
            },
        ],
        ...rest
    } = props;

    return (
        <Form.Item
            name={name}
            rules={rules}
            valuePropName="checked"
            {...rest}
        >
            <Checkbox className={'g-agree'}>
                <Trans
                    i18nKey="web_form_agree_tip"
                    components={{
                        privacy: (
                            <a target="_blank" href={generatePath(RouteEnum.HELP, { code: 'privacy-policy' })} rel="noreferrer"/>
                        ),
                        terms: (
                            <a target="_blank" href={generatePath(RouteEnum.HELP, { code: 'terms-of-service' })} rel="noreferrer"/>
                        ),
                    }}
                />
            </Checkbox>

        </Form.Item>
    )
};

export default FormRegisterAgree;